import React from "react";
import AdminSidebar from "../components/AdminSidebar";
import RecyclingControl from "../components/RecyclingControl";

const RecyclingControlPage = () => {
  return (
    <div style={{ display: "flex" }}>
      <AdminSidebar />
      <RecyclingControl />
    </div>
  );
};

export default RecyclingControlPage;
